import { noop } from "@flaminem/utils";
import { createContext, FC, ReactNode, useState } from "react";

import { getStoredLocale } from "src/internationalization/locale/getStoredLocale.ts";
import { SupportedLocale } from "src/internationalization/locale/supported.locale.enum.ts";

export type LocaleContextProps = {
  locale: SupportedLocale;
  changeLocale: (locale: SupportedLocale) => void;
};

export const LocaleContext = createContext<LocaleContextProps>({
  locale: getStoredLocale(),
  changeLocale: noop,
});

export const LocaleProvider: FC<{ children: ReactNode; overwrittenLocale?: SupportedLocale }> = ({
  children,
  overwrittenLocale,
}) => {
  const [locale, setLocale] = useState<SupportedLocale>(overwrittenLocale ?? getStoredLocale());
  const changeLocale = (locale: SupportedLocale) => {
    localStorage.setItem("locale", locale);
    setLocale(locale);
  };

  return (
    <LocaleContext.Provider value={{ locale, changeLocale }}>{children}</LocaleContext.Provider>
  );
};
